import { render, staticRenderFns } from "./afterSalesList.vue?vue&type=template&id=2052dd52"
import script from "./afterSalesList.vue?vue&type=script&lang=js"
export * from "./afterSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports